module.exports = __webpack_public_path__ + "img/40.8903907e.svg";